import { __spreadArrays } from "tslib";
import { isFunction } from './util/isFunction';
import { UnsubscriptionError } from './util/UnsubscriptionError';
var Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._singleParent = null;
        this._parents = null;
        this._teardowns = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _singleParent = this._singleParent;
            var _parents = void 0;
            if (_singleParent) {
                this._singleParent = null;
                _singleParent.remove(this);
            }
            else if ((_parents = this._parents)) {
                this._parents = null;
                for (var _i = 0, _parents_1 = _parents; _i < _parents_1.length; _i++) {
                    var parent_1 = _parents_1[_i];
                    parent_1.remove(this);
                }
            }
            var initialTeardown = this.initialTeardown;
            if (isFunction(initialTeardown)) {
                try {
                    initialTeardown();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [e];
                }
            }
            var _teardowns = this._teardowns;
            this._teardowns = null;
            if (_teardowns) {
                for (var _a = 0, _teardowns_1 = _teardowns; _a < _teardowns_1.length; _a++) {
                    var teardown_1 = _teardowns_1[_a];
                    try {
                        if (typeof teardown_1 === 'function') {
                            teardown_1();
                        }
                        else {
                            teardown_1.unsubscribe();
                        }
                    }
                    catch (err) {
                        errors = errors !== null && errors !== void 0 ? errors : [];
                        if (err instanceof UnsubscriptionError) {
                            errors = __spreadArrays(errors, err.errors);
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                if (typeof teardown === 'function') {
                    teardown();
                }
                else {
                    teardown.unsubscribe();
                }
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                this._teardowns = (_a = this._teardowns) !== null && _a !== void 0 ? _a : [];
                this._teardowns.push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _a;
        return this._singleParent === parent || ((_a = this._parents) === null || _a === void 0 ? void 0 : _a.includes(parent)) || false;
    };
    Subscription.prototype._addParent = function (parent) {
        var _singleParent = this._singleParent;
        var _parents;
        if (_singleParent) {
            this._parents = [_singleParent, parent];
            this._singleParent = null;
        }
        else if ((_parents = this._parents)) {
            _parents.push(parent);
        }
        else {
            this._singleParent = parent;
        }
    };
    Subscription.prototype._removeParent = function (parent) {
        var _singleParent = this._singleParent;
        var _parents;
        if (_singleParent) {
            if (_singleParent === parent) {
                this._singleParent = null;
            }
        }
        else if ((_parents = this._parents)) {
            var index = _parents.indexOf(parent);
            if (index >= 0) {
                _parents.splice(index, 1);
            }
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _teardowns = this._teardowns;
        if (_teardowns) {
            var index = _teardowns.indexOf(teardown);
            if (index >= 0) {
                _teardowns.splice(index, 1);
            }
        }
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    })(new Subscription());
    return Subscription;
}());
export { Subscription };
export function isSubscription(value) {
    return (value instanceof Subscription ||
        (value &&
            'closed' in value &&
            typeof value.remove === 'function' &&
            typeof value.add === 'function' &&
            typeof value.unsubscribe === 'function'));
}
//# sourceMappingURL=Subscription.js.map